export default "__VITE_PUBLIC_ASSET__24805f2a__"